
import { provideMockStore } from '@ngrx/store/testing';
import {
  AuthService,
} from './auth.service';
import { AuthServiceMock } from './auth.service.mock';
import {
  WithoutMetaButAllowId,
  DxUser
} from '@digitaix/types';

export function getStoreStateWithUser<User extends WithoutMetaButAllowId<DxUser>>(user: User) {
  return {
    dx: {
      auth: {
        user,
      }
    }
  }
}

export function provideMockStoreWithUser<User extends WithoutMetaButAllowId<DxUser>>(user: User) {
  return provideMockStore({
    initialState: getStoreStateWithUser<User>(user),
  })
}

export function createAuthServiceMockFactory<User>(user: User) {
  return () => {
    const auth = new AuthServiceMock<User>();
    auth.user.next(user);
    return auth;
  }
}

export function provideMockAuthService() {
  return {
    provide: AuthService,
    useFactory: createAuthServiceMockFactory,
    deps: []
  }
}
